const scrollManager = function(element, scrollSpeed = 0.5) {
    let callbacks = [];
    let animatedKilled = false;
    let scrollOffset = 0;

    const onScroll = () => {
        if (animatedKilled) return;

        if (scrollOffset !== 0) {
            callbacks.forEach(cb => cb(scrollOffset));
            scrollOffset = 0; // Reset after processing
            requestAnimationFrame(onScroll);
        }
    };

    const offsetAndPath = (e) => {

        // Adjust the scroll speed to make it independent of content width
        const normalizedScroll = e.deltaY * scrollSpeed;

        // Apply the scroll offset to scrollLeft directly
        scrollOffset = normalizedScroll;

        // Adjust the scroll position
        element.scrollLeft += scrollOffset;

        // Call onScroll through requestAnimationFrame to ensure smooth updates
        requestAnimationFrame(onScroll);
    };

    element.addEventListener('wheel', offsetAndPath, { passive: true });

    return {
        add(cb) {
            callbacks.push(cb);
        },
        remove(cb) {
            callbacks = callbacks.filter(value => value !== cb);
        },
        destroy() {
            animatedKilled = true;
            element.removeEventListener('wheel', offsetAndPath);
        }
    };
};

export default scrollManager;
